import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Ruler } from "lucide-react";

// Kurti Connection USA — unified size chart (all products).
// Indian size number with US / age equivalent, confirmed by store owner.
const SIZE_ROWS = [
  { brand: "22", fits: "2 years" }, { brand: "24", fits: "3-4 years" },
  { brand: "26", fits: "5-6 years" }, { brand: "28", fits: "7-8 years" },
  { brand: "30", fits: "9-10 years" }, { brand: "32", fits: "11 years" },
  { brand: "34", fits: "12 years" }, { brand: "36", fits: "13 years" },
  { brand: "38", fits: "US XS" }, { brand: "40", fits: "US SMALL" },
  { brand: "42", fits: "US M" }, { brand: "44", fits: "US L" },
  { brand: "46", fits: "US XL" }, { brand: "48", fits: "US XXL" },
  { brand: "50", fits: "US 3XL" }, { brand: "52", fits: "US 4XL" },
  { brand: "54", fits: "US 5XL" }, { brand: "56", fits: "US 6XL" },
  { brand: "58", fits: "US 7XL" }, { brand: "60", fits: "US 8XL" },
];

export const SizeGuideModal = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="size-guide-modal"
        className="max-w-lg bg-[#FFFFFF] border border-[#E5E5DF] p-0 gap-0 overflow-hidden"
      >
        <div className="px-6 pt-6 pb-4 border-b border-[#E5E5DF]">
          <div className="flex items-center gap-2 text-[#B84A3B] mb-1.5">
            <Ruler size={16} strokeWidth={1.8} />
            <span className="overline">Size Guide</span>
          </div>
          <DialogTitle className="font-display text-2xl tracking-tight text-[#1A1A1A]">
            Kurti Connection Size Chart
          </DialogTitle>
          <p className="text-sm text-[#6E6E69] mt-1.5 leading-relaxed">
            Every size on our site shows the Indian number with its US / age equivalent — pick whichever you know.
          </p>
        </div>

        <div className="px-6 py-5 max-h-[55vh] overflow-y-auto">
          <div className="overflow-hidden border border-[#E5E5DF] rounded-sm">
            <table className="w-full text-sm border-collapse" data-testid="size-guide-table">
              <thead>
                <tr className="bg-[#1A1A1A] text-[#FFFFFF]">
                  <th className="px-3 py-2.5 text-left font-mono text-[0.68rem] uppercase tracking-[0.08em] font-normal">Size</th>
                  <th className="px-3 py-2.5 text-left font-mono text-[0.68rem] uppercase tracking-[0.08em] font-normal">Fits Like</th>
                </tr>
              </thead>
              <tbody>
                {SIZE_ROWS.map((r, i) => (
                  <tr
                    key={r.brand}
                    data-testid={`size-row-${r.brand}`}
                    className={i % 2 === 0 ? "bg-white" : "bg-[#F3F2EC]"}
                  >
                    <td className="px-3 py-2.5 font-mono text-[#1A1A1A] border-t border-[#E5E5DF] font-medium">{r.brand}</td>
                    <td className="px-3 py-2.5 text-[#3A3A38] border-t border-[#E5E5DF]">{r.fits}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <ul className="mt-4 space-y-1.5 text-[0.78rem] text-[#6E6E69] leading-relaxed">
            <li className="flex gap-2"><span className="text-[#B84A3B]">•</span> Measurements include tailoring margins for a comfortable fit.</li>
            <li className="flex gap-2"><span className="text-[#B84A3B]">•</span> Measure over your undergarments, keeping the tape snug but not tight.</li>
            <li className="flex gap-2"><span className="text-[#B84A3B]">•</span> If you're between sizes, we recommend sizing up.</li>
          </ul>
        </div>
      </DialogContent>
    </Dialog>
  );
};
